import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize, Observable, Subject, tap } from 'rxjs';
import { AppConstants } from 'src/app/constants/app-constants';
import { PasswordChangeEntry } from 'src/app/model/PasswordChangeEntry';
import { PasswordRequestRecord } from 'src/app/model/PasswordRequestRecord';
import { environment } from 'src/environments/environment';
import { PASSWORD_RESET_RECORD_ENDPOINT, PASSWORD_RESET_RESET_ENDPOINT } from 'src/app/constants/api-routes';

/**
 * Password Request Service provides the functionality to request a password reset
 */
@Injectable({
  providedIn: 'root'
})
export class PasswordRequestService {
  /** Default constructor to initialize services */
  constructor(
    private _http: HttpClient,
    private _router: Router,
    private _toastrService: ToastrService,
  ) { }

  /**
   * Get the password request record associated with a provided GUID
   * 
   * @param guid The GUID to search for
   * @return The request record associated with the GUID, null if none
   */
  public getPasswordRequestRecord(guid: string): Observable<PasswordRequestRecord | null> {
    return this._http.get<PasswordRequestRecord | null>(PASSWORD_RESET_RECORD_ENDPOINT(guid));
  }

  /**
   * Change a user's password from the provided credentials
   * 
   * @param user Updated user object to save
   */
  public changePassword(entry: PasswordChangeEntry): Observable<any> {
    return this._http.put<any>(PASSWORD_RESET_RESET_ENDPOINT, entry);
  }
}
